const PurchaseGreenSvg = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_4036_31982)">
      <circle cx="20" cy="20" r="20" fill="#008001" fillOpacity="0.05" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.9997 27.8359C24.3259 27.8359 27.833 24.3288 27.833 20.0026C27.833 17.1038 26.2587 14.5721 23.916 13.2169C23.6769 13.0787 23.5953 12.7728 23.7335 12.5338C23.8718 12.2947 24.1777 12.213 24.4167 12.3513C27.0557 13.8779 28.833 16.7324 28.833 20.0026C28.833 24.8811 24.8782 28.8359 19.9997 28.8359C15.1212 28.8359 11.1663 24.8811 11.1663 20.0026C11.1663 16.7324 12.9437 13.8779 15.5826 12.3513C15.8217 12.213 16.1275 12.2947 16.2658 12.5338C16.4041 12.7728 16.3224 13.0787 16.0834 13.2169C13.7407 14.5721 12.1663 17.1038 12.1663 20.0026C12.1663 24.3288 15.6734 27.8359 19.9997 27.8359ZM20.3532 23.6894C20.158 23.8847 19.8414 23.8847 19.6461 23.6894L16.3128 20.3561C16.1175 20.1608 16.1175 19.8443 16.3128 19.649C16.5081 19.4537 16.8246 19.4537 17.0199 19.649L19.4997 22.1288L19.4997 11.6692C19.4997 11.3931 19.7235 11.1692 19.9997 11.1692C20.2758 11.1692 20.4997 11.3931 20.4997 11.6692L20.4997 22.1288L22.9795 19.649C23.1747 19.4537 23.4913 19.4537 23.6866 19.649C23.8818 19.8443 23.8818 20.1608 23.6866 20.3561L20.3532 23.6894Z"
        fill="#75B976"
      />
    </g>
    <defs>
      <clipPath id="clip0_4036_31982">
        <rect width="40" height="40" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default PurchaseGreenSvg;
